import * as React from "react";
function SvgIcUnpin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.567 20.158l.65.375 2.548-4.414 4.086 2.36.188-.325a3.783 3.783 0 00-.041-3.836l1.955-3.387.656-1.137A2.368 2.368 0 0018.6 8.618l.188-.325L11.352 4l-.187.325a2.368 2.368 0 00-.023 2.313L9.583 9.336 8.53 11.162a3.787 3.787 0 00-3.341 1.881L5 13.368l4.116 2.376-2.549 4.414zm6.991-2.716l-7.511-4.337a3.023 3.023 0 012.662-1.183l.238.02.12-.207 2.837-4.915.12-.206-.136-.197a1.615 1.615 0 01-.22-1.37l6.058 3.498a1.627 1.627 0 01-1.296.495l-.238-.02-.119.207-2.838 4.916-.12.206.137.196a3.027 3.027 0 01.306 2.897z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcUnpin;
